import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import ProcedureRecordManager from "./ProcedureRecordManager";
import QualificationRecordManager from "./QualificationRecordManager";
import PreviewQualificationManager from "./PreviewQualificationManager";
import QualificationPreviewSync from "./QualificationPreviewSync";
import ProfileQualificationDeleteManager from "./ProfileQualificationDeleteManager";
import QualificationExpiryGuard from "./QualificationExpiryGuard";
import QualificationSummaryBypass from "./QualificationSummaryBypass";
import MetricCardFilterManager from "./MetricCardFilterManager";
import EligibilityResultNavigation from "./EligibilityResultNavigation";
import EligibilityPositionGuard from "./EligibilityPositionGuard";
import DashboardQualificationNavigation from "./DashboardQualificationNavigation";
import GroupedWelderQualificationList from "./GroupedWelderQualificationList";
import CertificationSearchPortal from "./CertificationSearchPortal";
import QualificationCardCleanup from "./QualificationCardCleanup";
import QualificationFormSimplifier from "./QualificationFormSimplifier";
import QualificationSidebarHome from "./QualificationSidebarHome";
import DrawingViewer from "./DrawingViewer";
import MTRViewer from "./MTRViewer";
import ProjectDocumentViewer from "./ProjectDocumentViewer";
import InspectionRecordViewer from "./InspectionRecordViewer";
import InspectionProjectFolders from "./InspectionProjectFolders";
import MTRProjectFolders from "./MTRProjectFolders";
import NCRProjectFolders from "./NCRProjectFolders";
import NCRWeldIntegration from "./NCRWeldIntegration";
import MainNCRViewer from "./MainNCRViewer";
import MTRFormCleanup from "./MTRFormCleanup";
import RemovedRecordUiSync from "./RemovedRecordUiSync";
import ProjectProcedureActions from "./ProjectProcedureActions";
import W47ParentWpsSelector from "./W47ParentWpsSelector";
import SearchResultRecordNavigation from "./SearchResultRecordNavigation";
import WelderProfileLinkCleanup from "./WelderProfileLinkCleanup";
import ProjectProcedureHierarchy from "./ProjectProcedureHierarchy";
import ProjectProcedureLibraryStateFix from "./ProjectProcedureLibraryStateFix";
import ProjectWeldRegisterConsolidation from "./ProjectWeldRegisterConsolidation";
import ProjectOverviewWeldSync from "./ProjectOverviewWeldSync";
import WeldRegisterMetricFilter from "./WeldRegisterMetricFilter";
import InspectionWeldIntegration from "./InspectionWeldIntegration";
import "./styles.css";
import "./responsive-tables.css";
import "./tag-system.css";
import "./audit-page.css";
import "./form-placeholder.css";
import "./qualification-preview-profile.css";
import "./metric-card-filter.css";
import "./eligibility-result-navigation.css";
import "./profile-qualification-actions.css";
import "./grouped-welder-qualifications.css";
import "./procedure-program-filter.css";
import "./welder-profile-link-cleanup.css";
import "./project-procedure-selector-filter.css";
import "./project-procedure-hierarchy.css";
import "./project-wps-project-linker.css";
import "./project-complete-status.css";
import "./sidebar-navigation.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode><><App /><ProcedureRecordManager /><QualificationRecordManager /><PreviewQualificationManager /><QualificationPreviewSync /><ProfileQualificationDeleteManager /><QualificationExpiryGuard /><QualificationSummaryBypass /><MetricCardFilterManager /><EligibilityResultNavigation /><EligibilityPositionGuard /><DashboardQualificationNavigation /><GroupedWelderQualificationList /><CertificationSearchPortal /><QualificationCardCleanup /><QualificationFormSimplifier /><QualificationSidebarHome /><DrawingViewer /><MTRViewer /><ProjectDocumentViewer /><InspectionRecordViewer /><InspectionProjectFolders /><MTRProjectFolders /><NCRProjectFolders /><NCRWeldIntegration /><MainNCRViewer /><MTRFormCleanup /><RemovedRecordUiSync /><ProjectProcedureActions /><W47ParentWpsSelector /><SearchResultRecordNavigation /><WelderProfileLinkCleanup /><ProjectProcedureHierarchy /><ProjectProcedureLibraryStateFix /><ProjectWeldRegisterConsolidation /><ProjectOverviewWeldSync /><WeldRegisterMetricFilter /><InspectionWeldIntegration /></></StrictMode>
);
